module.exports = __webpack_public_path__ + "img/icon-gift-loyalty-gray.ac47e05e.svg";